import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ThreejsImage from "../ThreejsImagesPages/ThreejsImage";
import ThreejsImageMelee from "../ThreejsImagesPages/ThreejsImage_melee_common";
import ThreeJSImageCharacter from "../ThreejsImagesPages/ThreejsImageCharacter";
import environmentVariables from "../../../config/environmentVariables";

const ModelBack = `${environmentVariables?.cdnUrl}marker1.png`
const Root = styled.div`
  width: 100%;
  height: 500px;
  @media (max-width: 768px) {
    height: 300px;
  }
  @media (max-width: 1024px) {
    /* height: 300px; */
  }
`;

const Container = styled.div`
  justify-content: center;
  align-items: center;
  text-items: center;
  background-image: url(${ModelBack});
  background-size: cover;
  background-color: #fff;
  background-position: center;
  border-radius: 20px;
`;
const Imagewrapper = styled.div`
  background-size: cover;
  background-position: center;
  width: 100%;
  background-repeat: no-repeat;
`;

const BannerTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: flex-start;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
`;
const BannerText = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 54px;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "SweraDemo";
`;
const NftValueViewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* position: absolute; */
  top: 90%;
  height: 130px;
  background: linear-gradient(360deg, #000000 41.25%, rgba(0, 0, 0, 0) 100%);
`;

const RightLeftContainer = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: flex-start;
  width: 100%;
  /* @media(max-width:768px){
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    text-align: center;
  }  */
`;
const RightSideContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* width: 80%; */
  /* display: flex;
  justify-content:flex-start;
  width: 50%;
  z-index: 9999; */

  @media (max-width: 768px) {
    width: 55%;
  }
  @media (max-width: 650px) {
    width: 100%;
  }
`;
const LeftsideWrapper = styled.div`
  padding: 0 30px;
  width: 50%;
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
  @media (max-width: 768px) {
    width: 55%;
  }
  @media (max-width: 650px) {
    width: 100%;
  }
`;

const BidButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
`;

const Button = styled.button`
  background: #ffffff;
  border-radius: 30px;
  border: none;
  outline: none;
  padding: 15px 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #191919;
  cursor: pointer;
`;
const Buttonwrapper = styled.div`
  margin: 10px 0;
`;

const NftImmageWrapper = styled.div`
  background: linear-gradient(158deg, #151a1c, #000000);
  border-radius: 10px;
`;

const NftImage = styled.img`
  width: 100%;
  border-radius: 10px;
  /* padding: 150px 50px 100px; */
`;

const IconWrapper = styled.div``;
const Icon = styled.div``;
const BottomTextContainer = styled.div`
  /* position: absolute; */
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  bottom: 3px;
  border-radius: 0 0 30px 30px;
`;
const BottomTextWrapper = styled.div`
  /* width: 70%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;
const Text = styled.text`
  font-size: 24px;
  padding: 20px 30px;

  @media (max-width: 768px) {
    font-size: 21px;
  }
  @media (max-width: 425px) {
    font-size: 17px;
  }
`;

const MintingContainer = styled.div`
  display: flex;
  margin: 25px 0;
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
`;
const ValueText = styled.text`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  font-family: "sans-serif";
  line-height: 19px;
  text-transform: capitalize;
  color: #ffffff;
  margin: 5px 0;
  @media (max-width: 650px) {
    font-weight: 500;
    font-size: 16px;
  }
`;
const Value = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-transform: capitalize;
  font-family: "sans-serif";
  color: #ffffff;
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 650px) {
    font-weight: 500;
    font-size: 15px;
  }
`;

const LineWrapper = styled.div``;
const Line = styled.div`
  opacity: 0.2;
  border: 1px solid #ffffff;
  height: 58px;
  width: 0;
  margin: 0 30px;
  @media (max-width: 1260px) {
    margin: 0 20px;
  }
  @media (max-width: 650px) {
    margin: 0 14px;
  }
`;

const BackgroundBanner = ({ contractAddress, detailOfNftCentral }) => {
  const navigation = useNavigate();
  const getThreeJSModel = () => {
    if (contractAddress == "0x8fc3dec6148a9924870f205617c9c26b3010243e") {
      return <ThreejsImage detailOfNftCentral={detailOfNftCentral} />;
    } else if (
      contractAddress == "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
    ) {
      return <ThreejsImageMelee detailOfNftCentral={detailOfNftCentral} />;
    } else if (
      contractAddress == "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
    ) {
      return <ThreeJSImageCharacter detailOfNftCentral={detailOfNftCentral} />;
    }
  };
  return (
    <Root>
      <Container>
        {/* <Imagewrapper> */}
        {/* <RightLeftContainer> */}
        {/* <RightSideContainer> */}

        {/* <NftImmageWrapper>
                <NftImage src={image || NftSpecificNft} />
              </NftImmageWrapper> */}
        {/* <FbxFile/> */}
        {getThreeJSModel()}
        {/* </RightSideContainer> */}
        {/* <LeftsideWrapper>
              <BannerTextWrapper>
                <BannerText> {name} </BannerText>
              </BannerTextWrapper>
            </LeftsideWrapper> */}
        {/* </RightLeftContainer> */}
        {/* <NftValueViewContainer /> */}
        {/* </Imagewrapper> */}
      </Container>
    </Root>
  );
};

export default BackgroundBanner;
